import React, { useMemo } from 'react'
import { BasePriceContainer } from "pages/Legacy/components/BasePrice/style";
import { formatPrice } from "Utils";
import { PopoverHover } from "components/Popover";
import PopoverBasePrice from "pages/Legacy/components/BasePrice/PopoverBasePrice";


const BasePrice = ({value, row}: any)=> {

  const isDiff = useMemo(()=> {
    const bbPrice = row?.original?.buyboxPrice
    const optiScore = row?.original?.amazonOptiScore
    if(!bbPrice || !value) return false
    if(optiScore === 0) return false
    const ratio = value / bbPrice
    return ratio <= 0.8
  },[row, value])


  return (
    <PopoverHover Component={<PopoverBasePrice row={row} />}>
      <BasePriceContainer isDiff={isDiff}>
        {formatPrice(value)}
      </BasePriceContainer>
    </PopoverHover>
  )
}

export default BasePrice